/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

import { ACTION_GENERATOR_FRAGMENT } from '@/graphql'

export const GET_ACTION_GENERATORS = gql`
  query GetActionGenerators(
    $filters: ActionGeneratorFilter
    $pagination: OffsetPaginationInput
    $subFilters: ActionGeneratorFilter
    $subPagination: OffsetPaginationInput
  ) {
    tenantActionGenerators(filters: $filters, pagination: $pagination) {
      totalCount
      results {
        ...ActionGeneratorFragment
      }
    }
  }
  ${ACTION_GENERATOR_FRAGMENT}
`
